// src/redux/reducers/templatesReducer.js
// Redux reducer for managing assessment templates state

import {
  FETCH_TEMPLATE_START,
  FETCH_TEMPLATE_SUCCESS,
  FETCH_TEMPLATE_FAILURE,
  FETCH_ALL_TEMPLATES_START,
  FETCH_ALL_TEMPLATES_SUCCESS,
  FETCH_ALL_TEMPLATES_FAILURE
} from '../actions/templateActions';

/**
 * Templates state structure:
 * {
 *   byId: {
 *     [templateId]: {
 *       id, name, description, modelType, isDefault,
 *       taxonomy: { contextFields, riskAreas, rootCauses, ... },
 *       evaluationCriteriaRefs,
 *       createdAt, updatedAt, publishedAt
 *     }
 *   },
 *   allTemplates: [{ id, name, description, modelType, ... }],
 *   loading: boolean,
 *   error: string | null
 * }
 */

const initialState = {
  byId: {},           // Templates keyed by ID for fast lookup
  allTemplates: [],   // List of all available templates (for selection UI)
  loading: false,
  error: null
};

export default function templatesReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_TEMPLATE_START:
    case FETCH_ALL_TEMPLATES_START:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_TEMPLATE_SUCCESS:
      return {
        ...state,
        loading: false,
        byId: {
          ...state.byId,
          [action.payload.templateId]: action.payload.template
        }
      };

    case FETCH_ALL_TEMPLATES_SUCCESS:
      // Populate both allTemplates (for UI) and byId (for fast lookup)
      const byId = {};
      action.payload.forEach(template => {
        byId[template.id] = template;
      });

      return {
        ...state,
        loading: false,
        allTemplates: action.payload,
        byId: {
          ...state.byId,
          ...byId
        }
      };

    case FETCH_TEMPLATE_FAILURE:
    case FETCH_ALL_TEMPLATES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
}
